import { createAction } from '@ngrx/store';

export const updateShopifyIntegrationSuccess = createAction('[Onboarding] Update Shopify Integration Success');
export const updateShopifyIntegrationFailure = createAction('[Onboarding] Update Shopify Integration Failure');
